import { BpOptionGroups, BpOptions } from '../../../../services/database/mco/schema/public';

export type AssocBpOptionGroup = BpOptionGroups & {
  _: {
    bp_options: BpOptions[];
  };
};


export type AssocBpOption = BpOptions & {
  _: {
    bp_option_group: BpOptionGroups;
  };
};

export type SelectedOptionNames = {
  option_group_name: string;
  option_group_name_en: string;
  option_group_name_jp: string;
  option_name: string;
  option_name_en: string;
  option_name_jp: string;
};

export const bpOptionUtil = {
  getBpOptionGroupByBpOptionId(bp_option_groups: AssocBpOptionGroup[], bp_option_id: number) {
    /* bp_option_id에 해당하는 bp_option_group 찾기 */
    return bp_option_groups.find((bp_option_group) =>
      bp_option_group._.bp_options.find((bp_option) => bp_option.id == bp_option_id),
    );
  },

  getAllBpOptionsByBpOptionId(bp_option_groups: AssocBpOptionGroup[], bp_option_id: number): BpOptions[] {
    /* bp_option_id에 해당하는 bp_options 찾기 */
    const bp_option_group = this.getBpOptionGroupByBpOptionId(bp_option_groups, bp_option_id);
    if (!bp_option_group) return [];
    return bp_option_group._.bp_options;
  },

  getAllBpOptionIdsByBpOptionId(bp_option_groups: AssocBpOptionGroup[], bp_option_id: number): number[] {
    /* bp_option_id에 해당하는 bp_option_ids 찾기 */
    const bp_options = this.getAllBpOptionsByBpOptionId(bp_option_groups, bp_option_id);
    if (!bp_options) return [];
    return bp_options.map(({ id }) => id);
  },

  getBpOptionGroupByDevName(
    bp_option_groups: AssocBpOptionGroup[],
    dev_name: string,
  ): AssocBpOptionGroup | undefined {
    /* dev_name에 해당하는 bp_option_group 찾기 */
    return bp_option_groups.find((bp_option_group) => bp_option_group.dev_name === dev_name);
  },
  getBpOptionByIds(bp_option_group: AssocBpOptionGroup, bp_option_ids: number[]): BpOptions | undefined {
    /* dev_name에 해당하는 bp_option_group 찾기 */
    return bp_option_group._.bp_options.find((bp_option) => bp_option_ids.includes(bp_option.id));
  },

  makeOptionNamesByDevNameAndBpOptionId(
    bp_option_groups: AssocBpOptionGroup[],
    { selected_bp_option_ids, dev_name }: { selected_bp_option_ids: number[]; dev_name: string },
    custom_name?: { name: string; name_en: string; name_jp: string },
  ) {
    /* dev_name 과 bp_option_id 에 해당하는 option_names 찾기 */
    const bp_option_group = this.getBpOptionGroupByDevName(bp_option_groups, dev_name);
    if (!bp_option_group) return;
    return this.makeOptionNameByBpOptionGroup(bp_option_group, selected_bp_option_ids, custom_name);
  },

  makeOptionNameByBpOptionGroup(
    bp_option_group: AssocBpOptionGroup,
    selected_bp_option_ids: number[],
    custom_name?: { name: string; name_en: string; name_jp: string },
  ): SelctedOptionNames | undefined {
    const bp_option = bp_option_group._.bp_options.find((bp_option) =>
      selected_bp_option_ids.includes(bp_option.id),
    );
    if (!bp_option) return;

    return {
      option_group_name: bp_option_group.name,
      option_group_name_en: bp_option_group.name_en,
      option_group_name_jp: bp_option_group.name_jp,
      ...(custom_name
        ? {
            option_name: custom_name.name,
            option_name_en: custom_name.name_en,
            option_name_jp: custom_name.name_jp,
          }
        : {
            option_name: bp_option.name,
            option_name_en: bp_option.name_en,
            option_name_jp: bp_option.name_jp,
          }),
    };
  },

  makeOptionNames(bp_option_groups: AssocBpOptionGroup[], selected_bp_option_ids: number[]) {
    const option_names = bp_option_groups
      .filter((bp_option_group) => bp_option_group.is_name)
      .map((bp_option_group) => this.makeOptionNameByBpOptionGroup(bp_option_group, selected_bp_option_ids));
    return option_names;
  },

  findAssocBpOptionByDevName(bp_options: AssocBpOption[], dev_name: string) {
    return bp_options.find((option) => option._?.bp_option_group?.dev_name === dev_name);
  },
};
